// Adresse publique d'une exposition, construite sur l'origine du site ouvert.
//
// Elle était écrite en dur (https://marc-antoine-lune.github.io/at-expo/…),
// que GitHub redirige vers le domaine personnalisé du dépôt, test.logexpobu.fr.
// Or le front est aussi servi sous logexpobu.alpatechnologies.cloud, parce que
// le pare-feu de l'université bloque logexpobu.fr : l'aperçu y renvoyait donc
// vers une adresse inaccessible. Avec l'origine courante, chaque adresse du
// front produit des liens vers elle-même.
//
// Le routeur est en mode hash et publicPath vaut '/' : l'exposition vit à
// <origine>/#/expo/<template>/<id>.
export function urlExposition(template, id) {
  return `${window.location.origin}/#/expo/${template}/${id}`;
}
